import { useEffect } from "react";
import { PagesInventoryArchiverUiDisplay } from "./Display";

export const PagesInventoryArchiverUi = () => {
  useEffect(() => {
    document.title = "Inventory Archiver";
  }, []);
  return <PagesInventoryArchiverUiDisplay />;
};
